import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { SortDirection } from '../../../../../enums/sortDirection'
import { BankMatchesSortProperty } from '../enums/bankMatchesSortProperty'

export interface BankMatchesSortFilterDropdownValue {
  direction: SortDirection
  property: BankMatchesSortProperty
}

export const getSortFilterId = (sortProperty: BankMatchesSortProperty, direction: SortDirection) =>
  `${sortProperty}-${direction}`

export const getSortingItems = (t: TFunction): NavItem<BankMatchesSortFilterDropdownValue>[] => [
  {
    children: t('bank_integration.toolbar.sort_filter.date_desc'),
    id: getSortFilterId(BankMatchesSortProperty.EntryDate, SortDirection.Desc),
    value: {
      direction: SortDirection.Desc,
      property: BankMatchesSortProperty.EntryDate,
    },
  },
  {
    children: t('bank_integration.toolbar.sort_filter.date_asc'),
    id: getSortFilterId(BankMatchesSortProperty.EntryDate, SortDirection.Asc),
    value: {
      direction: SortDirection.Asc,
      property: BankMatchesSortProperty.EntryDate,
    },
  },
  {
    children: t('bank_integration.toolbar.sort_filter.amount_desc'),
    id: getSortFilterId(BankMatchesSortProperty.SideAmount, SortDirection.Desc),
    value: {
      direction: SortDirection.Desc,
      property: BankMatchesSortProperty.SideAmount,
    },
  },
  {
    children: t('bank_integration.toolbar.sort_filter.amount_asc'),
    id: getSortFilterId(BankMatchesSortProperty.SideAmount, SortDirection.Asc),
    value: {
      direction: SortDirection.Asc,
      property: BankMatchesSortProperty.SideAmount,
    },
  },
]
